const PENDING_QR_KEY = 'pakda:pending-native-qr:v1';
const PENDING_QR_TTL_MS = 5 * 60 * 1000;

interface PendingQr {
  nas: string;
  code: string;
  createdAt: number;
}

export function prepareNativeQrHandoff(nas: string, code: string, loginUrl: string, storage: Storage = window.sessionStorage, now = Date.now()): string {
  if (!isSafeLocalHotspotUrl(loginUrl) || !/^[A-Za-z0-9_-]{6,255}$/.test(code)) throw new Error('Este QR no corresponde al acceso WiFi de este bus.');
  storage.setItem(PENDING_QR_KEY, JSON.stringify({ nas, code, createdAt: now } satisfies PendingQr));
  return loginUrl;
}

function isSafeLocalHotspotUrl(value: string) {
  try {
    const url = new URL(value);
    const octets = url.hostname.split('.').map(Number);
    const privateIp = octets.length === 4 && octets.every((part) => Number.isInteger(part) && part >= 0 && part <= 255) && (
      octets[0] === 10 || (octets[0] === 172 && octets[1] >= 16 && octets[1] <= 31) || (octets[0] === 192 && octets[1] === 168)
    );
    return url.protocol === 'http:' && url.port === '' && url.pathname === '/login' && url.search === '' && url.hash === '' && privateIp;
  } catch { return false; }
}

export function consumeNativeQrCode(nas: string, storage: Storage = window.sessionStorage, now = Date.now()): string {
  let raw: string | null;
  try {
    raw = storage.getItem(PENDING_QR_KEY);
    storage.removeItem(PENDING_QR_KEY);
  } catch {
    return '';
  }
  if (!raw) return '';
  try {
    const pending = JSON.parse(raw) as Partial<PendingQr>;
    return pending.nas === nas
      && typeof pending.code === 'string'
      && /^[A-Za-z0-9_-]{6,255}$/.test(pending.code)
      && typeof pending.createdAt === 'number'
      && now >= pending.createdAt
      && now - pending.createdAt <= PENDING_QR_TTL_MS
      ? pending.code : '';
  } catch {
    return '';
  }
}
